import { defineTheme } from './definition';
import { mixSimplePaletteColor } from './definition/utils';

export default defineTheme({
	name: 'base',
	appearance: 'light',
	palette: {
		primary: mixSimplePaletteColor('#2663eb', '#ffffff', '#000000'),
		neutral: {
			50: '#FAFAFA',
			100: '#F5F5F5',
			200: '#E5E5E5',
			300: '#D4D4D4',
			400: '#A0A0A0',
			500: '#777777',
			600: '#555555',
			700: '#404040',
			800: '#262626',
			900: '#151515',
			950: '#090909',
		},
		error: {
			50: '#FDF0F1',
			100: '#FBE3E6',
			200: '#F8C7CC',
			300: '#F3A1AA',
			400: '#ED7280',
			500: '#E74355',
			600: '#D9263A',
			700: '#A32936',
			800: '#77222C',
			900: '#602027',
			950: '#391317',
		},
		warning: {
			50: '#FFFCF0',
			100: '#FFF9E3',
			200: '#FFF4CC',
			300: '#FFEBA2',
			400: '#FFE074',
			500: '#FFD646',
			600: '#F4C625',
			700: '#DAA60B',
			800: '#B78900',
			900: '#795C06',
			950: '#472C06',
		},
		success: {
			50: '#EEFBF7',
			100: '#DFF7F0',
			200: '#C0EFE1',
			300: '#95E4CD',
			400: '#61D7B3',
			500: '#2CC99A',
			600: '#28A681',
			700: '#248F6F',
			800: '#22775D',
			900: '#174F3E',
			950: '#0F2E25',
		},
		info: mixSimplePaletteColor('#2663eb', '#ffffff', '#000000'),
		orange: mixSimplePaletteColor('#FF8733', '#ffffff', '#000000'),
	},
});
